<template>
  <div>
    <div class="recomended-list">
        <div v-bind:key="video_2.id.videoId" v-for="video_2 in recomended_videos">
            <RecomendedBox v-bind:video_2="video_2"/>
        </div>
    </div>
  </div>
</template>

<script>

import RecomendedBox from './RecomendedBox'
export default {
  name: 'RecomendedList',
  props: ['video_2','recomended_videos'],
  components:{
      RecomendedBox
  },
};
</script>

<style scoped>
.card-body{
  background-color: rgba(96, 180, 213, 0.3);
  transition-duration: 0.6s;
  width: 800px;
}
.card-body:hover{
  background-color: rgba(96, 180, 213, 0.7);
  transition-duration: 0.6s;
}

.recomended-list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
}
@media (max-width: 1200px){
  .card-body{
    width: 600px;
  }
}
@media (max-width: 1000px){
  .card-body{
    width: 500px;
  }
}
@media (max-width: 800px){
  .card-body{
    width: 400px;
  }
}
@media (max-width: 600px){
  .card-body{
    width: 300px;
  }
}
</style>